/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import axios from 'axios';
import { CotizadorContext } from '../context';

const useSimulationData = () => {
    const [state, setState] = useContext(CotizadorContext)

    return {
        simulation_results: state.simulation_results,
    };
}

export default useSimulationData;